import { z } from 'zod';

import { Channel } from '@/survey-graphql';

import { THEYSAID_PANEL_URL_CHANNEL } from './shared-survey.consts';

const channelSchema = z.enum(Channel);

export function resolveUrlChannel(
  raw: string | null | undefined
): Channel | null {
  if (raw === THEYSAID_PANEL_URL_CHANNEL) {
    return Channel.TheySaidPanel;
  }

  const parsed = channelSchema.safeParse(raw);

  return parsed.success ? parsed.data : null;
}
